import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {ORDER_HEADERS} from './orderHeaders'

export const useUpdateOrderApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({orderId, ...updateParams}: Params.UpdateOrderRequest) => {
      const {data} = await ventrata.patch<Ventrata.Order>(`/orders/${orderId}`, updateParams, {
        headers: ORDER_HEADERS,
      })

      return data
    },
    [ventrata]
  )
}
